<template>
    <scroll-box
    :data="data" 
    :loading="loading"
    :total="total"
    :showMore="showMore"
    emptyText="暂不支持获取语音通话内容"
    @loadMore="$emit('loadMore')">
        <template #left="scope">
            <audio-record :src="scope.row.audioUrl" type="left"></audio-record>
        </template>
        <template #right="scope">
            <audio-record :src="scope.row.audioUrl" type="right"></audio-record>
        </template>
    </scroll-box>
</template>
<script>
import scrollBox from './lib/scroll-box.vue'
import scrollBox2 from './lib/scroll-box2.vue'
import audioRecord from './lib/audio-record.vue'
export default {
    components: { scrollBox, audioRecord, scrollBox2 },
    props: {
        data: {
            type: Array,
            default() { return [] }
        },
        total: {
            type: Number,
            default() { return 0 }
        },
        loading: {
            type: Boolean,
            default() { return false }
        },
        showMore: {
            type: Boolean,
            default() { return false }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>